const CriticalWindow = () => {
  return (
    <section className='section relative overflow-hidden bg-gradient-to-br from-teal-950 via-teal-800 to-teal-600 text-white'>
      <div className='pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full border border-white/10 sm:h-96 sm:w-96' />
      <div className='pointer-events-none absolute -bottom-32 left-1/3 h-72 w-72 rounded-full border border-white/10' />
      <div className='container'>
        <div className='relative grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-16'>
          <div className='flex justify-center items-center'>
            <div className='relative h-64 w-64 sm:h-72 sm:w-72 md:h-80 md:w-80 lg:h-96 lg:w-96'>
              <div className='absolute -inset-3 rounded-[2rem] border border-teal-200/30' />
              <div className='relative h-full w-full overflow-hidden rounded-[1.75rem] shadow-2xl shadow-black/40'>
              <video
                className='w-full h-full object-cover'
                src='/videos/0_Brain_Technology_2160x3840.mp4'
                autoPlay
                loop
                muted
                playsInline
              />
              </div>
            </div>
          </div>
          <div className='text-center lg:text-left space-y-4'>
            <p className='text-xs font-bold uppercase tracking-[0.28em] text-teal-200'>
              The early years matter most
            </p>
            <h2 className='section-title mb-5 text-white'>
              Critical Development Window
            </h2>
            <div className='border-l-2 border-teal-300 pl-5 text-left sm:pl-6'>
              <p className='text-6xl font-black leading-none tracking-tight text-white sm:text-7xl'>
                90<span className='text-teal-200'>%</span>
              </p>
              <p className='mt-3 max-w-md text-base font-medium leading-relaxed text-teal-50 sm:text-lg'>
                of your child&apos;s brain development happens by age 7.
              </p>
            </div>
            <p className='max-w-xl text-base leading-relaxed text-teal-100 sm:text-lg'>
              Birth to 7 is a powerful window for building the foundations of
              learning, focus, and emotional growth. The right support now can
              shape how your child learns for years to come.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CriticalWindow;
